import React from 'react';

export const useRedirectToMessagesHook = (props) => {
  const { isMessagingOnly, location, history, enableFeeds } = props;
  const onAllowedFeedsPath =
    location.pathname === '/feeds' || location.pathname.startsWith('/feeds/');
  const shouldRedirect =
    isMessagingOnly && location.pathname !== '/messages' && !onAllowedFeedsPath;
  const redirectRoute = enableFeeds ? '/feeds' : '/messages';
  React.useEffect(() => {
    if (shouldRedirect) {
      history.push(redirectRoute);
    }
  }, [shouldRedirect, history, redirectRoute]);

};
